export const EMAIL_REG = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;

export const REGS = {
  EMAIL_REG,
};
